import React from "react";

import ActivityLog from "../../logging/activityLog";
import DeviceEventLogList from "./deviceEventLogList";
import RowList from "../../../components/common/rowList";
import ModalManager from "../../../components/common/modal/ModalManager";
import TextInput from "../../../components/common/inputs/textInput";
// import { formatDuration, intervalToDuration } from "date-fns";
import Loading from "../../../components/common/loading";
import axios from "axios";
import { format, formatDistanceToNow } from "date-fns";

export default class DeviceDetails extends React.Component {
  state = {
    granularity: null,
    loading: false,

    deviceName: "",
    deviceNameLoading: false,

    conf: null,
    confLoading: false,

  };
  componentDidMount = async () => {
    if (this.props.device?.enclosureSerialNumber) {
      this.setState({
        deviceName: this.props.device.deviceName,
      });
      if (!this.props.conf && !this.props.refreshConf) {
        this.grabConf({ cache: true });
      }
      // this.props.grabActivityLog();
    }
  };

  componentDidUpdate = (prevProps) => {
    const prevSerial = prevProps.device?.enclosureSerialNumber;
    const currentSerial = this.props.device?.enclosureSerialNumber;
    if (currentSerial && currentSerial !== prevSerial) {
      this.setState({
        deviceName: this.props.device.deviceName,
      });
      if (!this.props.conf && !this.props.refreshConf) {
        this.grabConf({ cache: true });
      }
      // this.props.grabActivityLog();
    }
  };


  onUnpairButtonPress = () => {
    ModalManager.confirm(
      "This action will unpair the PDU from your account. You can pair the PDU again by logging in directly to the PDU.",
      "Unpair PDU",
      "Confirm",
      (submitted, close) => {
        if (submitted) {
          this.props.unpair(() => {
            close();
          });
        } else {
          // close
        }
      }
    );
  };

  onSaveClick = () => {
    this.setState({ loading: true });
    this.props.modifyResource(
      "devices",
      this.props.device.enclosureSerialNumber,
      {
        // cloudPostIntervalMs: this.state.granularity * 1000,
        deviceName: this.state.deviceName,
      },
      () => {
        this.setState({ loading: false });
      },
      "enclosureSerialNumber"
    );
  };

  grabConf = ({ cache }) => {
    if (!this.props.device?.enclosureSerialNumber) return;
    if (this.props.refreshConf) {
      this.props.refreshConf({
        useCache: cache,
        force: !cache,
        device: this.props.device,
      });
      return;
    }
    this.setState({ confLoading: true });

    const isLte = this.props.device?.modelNumber?.endsWith("M01");
    const useCache = cache && !isLte;

    axios
      .get(
        `/v2/conf?${useCache ? "cache=true" : "cache=false"}&enclosure_serial_number=${this.props.device.enclosureSerialNumber}`,
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      )
      .then((res) => {
        this.setState({
          conf: (res.data?.data || [])[0],
          confLoading: false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ confLoading: false });
      });
  };

  render() {
    const { device, resources = {} } = this.props;
    if (!device) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
          }}
        >
          <Loading black size={30}/>
        </div>
      );
    }
    const isOnline = device.connectionState === "Connected";
    const outlets = device.outlets.filter(
      (o) => o.enclosureSerialNumber === device.enclosureSerialNumber
    );
    const hasEdit = this.props.device.deviceName !== this.state.deviceName;

    const confFromState = this.state.conf;
    const confLoadingFromState = this.state.confLoading;
    const conf = this.props.conf ?? confFromState;
    const confLoading = this.props.confLoading ?? confLoadingFromState;
    const skeletonValue = (
      <div
        className="skeleton-blank"
        style={{ width: "120px", height: "14px", margin: 0, padding: 0 }}
      />
    );
    const deviceSerial =
      device.enclosureSerialNumber === undefined ||
      device.enclosureSerialNumber === null
        ? null
        : String(device.enclosureSerialNumber);
    const groupsLoading = resources.groupsLoading;
    const groupsLoaded = resources.groupsLoaded;
    const availableGroups = Array.isArray(resources.groups)
      ? resources.groups
      : [];
    const deviceGroups =
      deviceSerial && availableGroups.length
        ? availableGroups.filter((group) => {
            if (group?.groupType !== "devices") return false;
            const items = Array.isArray(group.items) ? group.items : [];
            return items.some((item) => String(item) === deviceSerial);
          })
        : [];
    const deviceGroupsValue =
      groupsLoading && !groupsLoaded
        ? skeletonValue
        : deviceGroups.length > 0
        ? (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "6px",
              }}
            >
              {deviceGroups.map((group, index) => (
                <span
                  key={`${group?.id || group?.name || "group"}-${index}`}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "2px 10px",
                    borderRadius: "999px",
                    backgroundColor: "#eef2ff",
                    fontSize: "12px",
                    fontWeight: 500,
                    color: "#1f2937",
                  }}
                >
                  {group?.name || (group?.id ? `Group ${group.id}` : "Unnamed Group")}
                </span>
              ))}
            </div>
          )
        : "Not in any device groups";

    const ipAddress = (() => {
      if (!conf) return "-";
      if (conf.ipAssign === "dhcp" && conf.dhcpAssignedIp) {
        return `${conf.dhcpAssignedIp} (DHCP)`;
      }
      if (conf.ipAssign === "static" && conf.staticIp) {
        return `${conf.staticIp} (Static)`;
      }
      return "-";
    })();

    const gatewayIp = (() => {
      if (!conf) return "-";
      if (conf.ipAssign === "dhcp" && conf.dhcpGatewayIp) {
        return `${conf.dhcpGatewayIp} (DHCP)`;
      }
      if (conf.ipAssign === "static" && conf.staticGatewayIp) {
        return `${conf.gatewayIp} (Static)`;
      }
      return "-";
    })();

    const currentInterface = (() => {
      const route = conf?.currentDefaultRoute || "";
      if (route.includes("ppp")) return "Cellular";
      if (route.includes("eth")) return "Ethernet";
      return route || "-";
    })();

    const secondaryInterfaceUp =
      conf?.secondInterfaceStatus &&
      conf.secondInterfaceStatus.toString().toUpperCase().includes("UP");

    const secondaryIp = (() => {
      if (!conf) return "-";
      if (
        conf.secondaryIpAssign === "dhcp" &&
        conf.secondaryDhcpAssignedIp
      ) {
        return `${conf.secondaryDhcpAssignedIp} (DHCP)`;
      }
      if (
        conf.secondaryIpAssign === "static" &&
        conf.secondaryStaticIp
      ) {
        return `${conf.secondaryStaticIp} (Static)`;
      }
      return "-";
    })();

    const inletConfigValue =
      device.inletConfig === "standard"
        ? "Standard"
        : device.inletConfig === "ats"
        ? "Automatic Transfer Switch (ATS)"
        : device.inletConfig === "dualcircuit"
        ? "Dual Circuit"
        : "-";

    const rows = [
      {
        label: "Hostname",
        value: confLoading ? skeletonValue : conf?.hostName || "-",
      },
      {
        label: "MAC Address",
        value: confLoading ? skeletonValue : conf?.macAddr || "-",
      },
      {
        label: "IP Address",
        value: confLoading ? skeletonValue : ipAddress,
      },
      {
        label: "Current Network Interface",
        value: confLoading ? skeletonValue : currentInterface,
        disabled: conf?.currentDefaultRoute ? false : true,
      },
      {
        label: "Gateway IP",
        value: confLoading ? skeletonValue : gatewayIp,
      },
      {
        label: "Subnet Mask",
        value: confLoading ? skeletonValue : conf?.subnetMask || "-",
      },
    ];

    if (conf?.enableCellular) {
      rows.push({
        label: "LTE Policy",
        value: confLoading ? skeletonValue : conf.ltePolicy || "-",
      });
    }

    if (secondaryInterfaceUp) {
      rows.push(
        { label: "Secondary Interface Status", value: confLoading ? skeletonValue : "Up" },
        { label: "Secondary IP Address", value: confLoading ? skeletonValue : secondaryIp },
        {
          label: "Secondary MAC Address",
          value: confLoading ? skeletonValue : conf?.secondaryMacAddr || "-",
        }
      );
    }

    const infoRows = []
    infoRows.push(
      {
        label: "Connection Status",
        value: (
          <span
            style={{
              color: isOnline ? "forestgreen" : "maroon",
              fontWeight: "600",
            }}
          >
            {device.connectionState}
          </span>
        ),
      },
      {
        label: "Model Number",
        value: device.modelNumber,
        valueStyle: {},
      },
      {
        label: "Enclosure Serial Number",
        value: device.enclosureSerialNumber,
      },
      {
        label: "Outlet Switching",
        value: device.outletSwitchingSupported ? "Supported" : "Not Supported",
      },
      {
        label: "Outlet Power Measurements",
        value: device.outletPwrMeasurementsSupported
          ? "Supported"
          : "Not Supported",
      },
      { label: "Number of Outlets", value: device.numOutlets },
      {
        label: "Number of Relay Outputs",
        value: device.numDryContactRelays,
        disabled: device.numDryContactRelays === 0,
      },
      { label: "Inlet Configuration", value: inletConfigValue },
      { label: "Form Factor", value: device.formFactor },
      { label: "Device Groups", value: deviceGroupsValue }
    );

    return (
      <div className="grid-container">
        <div className="grid-x grid-padding-x grid-padding-y">
          <div className="cell large-6 medium-6">
            <div style={{}}>
                <div>
                  <div>
                    <div>
                      <TextInput
                        label="Device Name"
                        value={this.state.deviceName}
                        callback={(txt) => {
                          this.setState({ deviceName: txt });
                        }}
                        placeholder="Enter Device Name"
                        readOnly={!isOnline}
                      />
                    </div>

                    {hasEdit && (
                      <div
                        className="button"
                        onClick={() => this.onSaveClick()}
                      >
                        {this.state.loading ? <Loading /> : "Save"}
                      </div>
                    )}
                  </div>
                </div>
              {/* )} */}
              <h5
                style={{
                  // marginLeft: "10px",
                  marginBottom: "10px"
                }}
              >
                Device Information
              </h5>
              <RowList rows={infoRows} />

              <h5
                style={{
                  // marginLeft: "10px",
                  marginBottom: "10px",
                  marginTop: "30px",
                  display: "flex",
                  alignItems: "center"
                }}
              >
                <span>Network Information</span>
                {confLoading ? (
                  <span style={{ marginLeft: "10px" }}>
                    <Loading size={16} />
                  </span>
                ) : (
                  <span
                    style={{ cursor: "pointer", marginLeft: "10px" }}
                    onClick={() => this.grabConf({ cache: false })}
                  >
                    <i className="material-icons" style={{ fontSize: "20px" }}>refresh</i>
                  </span>
                )}
              </h5>
              <RowList rows={rows} />
              <FwUpdateStatus
                {...this.props}
              />
              <div
                style={{
                  paddingTop: "30px",
                }}
              >
                <div>Unnpair PDU from Synaccess Cloud Account</div>
                <div
                  className="button"
                  style={{
                    backgroundColor: "maroon",
                    marginTop: "10px",
                  }}
                  onClick={() => this.onUnpairButtonPress()}
                >
                  Unpair Now
                </div>
              </div>
            </div>
          </div>
          {!(this.props.user.role && !this.props.user.role.viewActivityLog) && (
            <div className="cell large-6 medium-6">
              <div
                style={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '1rem',
                }}
              >
                <div style={{ height: '50vh' }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      // paddingBottom: '1rem',
                      alignItems: 'center',
                      paddingLeft: "15px"
                    }}
                  >
                    <span style={{ fontWeight: '600', fontSize: '110%' }}>Activity Logs</span>
                  </div>
                  <ActivityLog
                    outlets={outlets}
                    devices={[device]}
                    selectedDevice={device}
                    activity={this.props.activityLog}
                    meta={this.props.activityMeta}
                    page={this.props.activityPage}
                    onPageChange={(p) => this.props.grabActivityLog(p)}
                    refresh={() => {
                      this.props.grabActivityLog(this.props.activityPage);
                    }}
                    onFilter={this.props.onFilter}
                    loading={this.props.activityLoading}
                  />
                </div>
                <div style={{ height: '50vh' }}>
                  <DeviceEventLogList device={device} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}


class FwUpdateStatus extends React.Component {
  state = {
    loading: false, // For indicating "Firmware Update" button press in progress
    polling: false, // Track whether we have an ongoing polling interval
    error: null, // For any error messages (TBD how you show them)
  };
  pollingInterval = null;

  // sometimes the fwStatus will be loaded on component did mount. and if so, check if the status is inProgress and if so then start polling
  // if the fwStatus is not loaded, then use componentDidUpdate to check if the status is inProgress and if so then start polling
  componentDidMount = () => {
    const { fwStatus, fwStatusLoaded } = this.props.resources;
    if (fwStatusLoaded && fwStatus?.updateStatus === "inProgress") {
      this.startPolling();
    }
  };
  componentDidUpdate = (prevProps) => {
    const { fwStatus, fwStatusLoaded } = this.props.resources;
    if (
      fwStatusLoaded &&
      fwStatus?.updateStatus === "inProgress" &&
      !this.state.polling
    ) {
      this.startPolling();
    }
  };
  componentWillUnmount = () => {
    this.stopPolling();
  };
  startPolling = () => {
    if (this.state.polling) {
      return;
    }
    this.setState({
      polling: true,
    });
    this.props.fetchFwStatus(this.props.device?.enclosureSerialNumber);
    this.pollingInterval = setInterval(() => {
      this.props.fetchFwStatus(this.props.device?.enclosureSerialNumber);
    }, 12000);
  };
  stopPolling = () => {
    this.setState({
      polling: false,
    });
    clearInterval(this.pollingInterval);
  };

  initiateFirmwareUpdate = async (fwVersion) => {
    this.setState({
      loading: true,
      error: null,
    });

    try {
      const response = await axios.post(
        `/v1/devices/${this.props.device?.enclosureSerialNumber}/fwUpdate`,
        { firmwareVersion: fwVersion },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      // If successful (200)
      if (response?.status === 200) {
        // start polling
        this.startPolling();
      } else {
        // Not a 200 => handle as error
        // In practice, you might show a notification or set state for error
        this.setState({
          error: "Unable to initiate firmware update (non-200).",
        });
      }
    } catch (error) {
      console.error(error);
      const errMessage = error?.response?.data?.message
      this.setState({
        error: errMessage || "Unable to initiate firmware update. Check console for details.",
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  render() {
    // const { fwStatus, fwStatusLoading, fwStatusLoaded } = this.props.resources;
    const fwStatuses = this.props.resources.fwStatus;
    const foundFwStatus = fwStatuses?.find(
      (f) => f.enclosureSerialNumber == this.props.device?.enclosureSerialNumber
    );
    const fwStatus = foundFwStatus?.fwStatus;
    const fwStatusLoading = foundFwStatus?.loading;
    const fwStatusLoaded = foundFwStatus?.loaded;
    const lastUpdated = foundFwStatus?.lastUpdated;
    const { loading, error } = this.state;

    // Extract interesting fields from fwStatus
    const currentFwVersion = fwStatus?.currentFwVersion;
    const latestFwVersion = fwStatus?.latestFwVersion;
    const availableUpdate = fwStatus?.availableUpdate;
    const updateStatus = fwStatus?.updateStatus; // "inProgress", "success", "failed", or ""
    const updatePendingFirmware = fwStatus?.updatePendingFirmware;
    const updateInitiatedTime = fwStatus?.updateInitiatedTime;
    const secondsSinceInitiated = fwStatus?.secondsSinceInitiated;
    const skeletonLine = (
      <div
        className="skeleton-blank"
        style={{ width: "120px", height: "14px", margin: 0, padding: 0 }}
      />
    );
    return (
      <div
        style={{
          marginTop: "30px",
          marginBottom: "20px",
          backgroundColor: "",
          // padding: "10px 20px",
          // boxShadow: "3px 3px 10px rgb(0 0 0 / 10%)",
        }}
      >
        <h5 style={{ marginBottom: "10px" }}>Firmware Update</h5>

        {fwStatusLoading && !fwStatusLoaded && (
          <RowList
            rows={[
              { label: "Current Firmware", value: skeletonLine },
            ]}
          />
        )}

        {/* Show any error messages (TBD how you want to style/handle them) */}
        {error && <div style={{ color: "maroon", marginLeft: "5px", marginBottom: "20px" }}>{error}</div>}

        {/* If we have fwStatus data */}
        {fwStatus && (
          <>
            <RowList
              rows={[
                {
                  label: "Current Firmware",
                  value: (
                    <div style={{ display: 'flex' }}>
                      {currentFwVersion} {currentFwVersion === latestFwVersion && "(Up to date)"}
                      {fwStatusLoading ? (
                        <Loading black />
                      ) : (
                        <span
                          style={{
                            marginLeft: "10px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                          }}
                          onClick={() =>
                            this.props.fetchFwStatus(
                              this.props.device?.enclosureSerialNumber
                            )
                          }
                        >
                          <i className="material-icons">refresh</i>
                        </span>
                      )}
                    </div>
                  ),
                },
                availableUpdate && updateStatus != "inProgress" && {
                  label: "Available Firmware Update",
                  value: (
                    <div>
                      <button
                        className="button"
                        style={{ margin: "0px" }}
                        onClick={() =>
                          this.initiateFirmwareUpdate(latestFwVersion)
                        }
                        disabled={loading}
                      >
                        {loading ? "Updating..." : "Firmware Update Device"}
                      </button>
                    </div>
                  ),
                },
              ].filter(Boolean)}
            />
            {/* <div>Current Firmware</div>
            <div style={{ fontWeight: "bold" }}>
              {currentFwVersion}{" "}
              {currentFwVersion === latestFwVersion && "(Up to date)"}
            </div> */}

            {/* {availableUpdate && updateStatus != "inProgress" && (
              <div>
                <div>Available Firmware Update</div>
                <div style={{ fontWeight: "bold" }}>{latestFwVersion}</div>

                <div
                  style={{
                    marginTop: "20px",
                  }}
                >
                  <button
                    className="button"
                    onClick={() => this.initiateFirmwareUpdate(latestFwVersion)}
                    disabled={loading}
                  >
                    {loading ? "Updating..." : "Firmware Update Device"}
                  </button>
                </div>
              </div>
            )} */}
            {/* No update available */}
            {/* {!availableUpdate && fwStatusLoaded && (
              <div style={{ margin: "10px 10px 20px 0px" }}>
                <em>No firmware update available</em>
              </div>
            )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              Last Checked:{" "}
              {lastUpdated ? new Date(lastUpdated).toLocaleString() : "N/A"}
              {fwStatusLoading ? (
                <span style={{ marginLeft: "10px" }}>
                  <Loading black />
                </span>
              ) : (
                <span
                  style={{
                    marginLeft: "10px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onClick={() =>
                    this.props.fetchFwStatus(
                      this.props.device?.enclosureSerialNumber
                    )
                  }
                >
                  <i className="material-icons">refresh</i>
                </span>
              )}
            </div> */}

            <div
              style={{
                // borderTop: "solid rgba(0,0,0,0.2) 1px",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            />
            {updateInitiatedTime &&
            <div
              style={{
                backgroundColor: "rgb(236 239 243)",
                padding: "15px",
                border: "solid #ccc 1px",
                borderRadius: "3px",
                fontSize: "90%",
              }}
            >
              {updateInitiatedTime && updateStatus === "inProgress" && (
                <div>
                  <div style={{ marginBottom: "", fontSize: "110%" }}>
                    Update History
                  </div>
                  <div
                    style={{
                      color: "#777",
                      fontSize: "91%",
                    }}
                  >
                    {format(new Date(updateInitiatedTime), "MMM d, HH:mm ")} -
                    Initiated{" "}
                    {formatDistanceToNow(new Date(updateInitiatedTime))} ago
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    Firmware update to version {updatePendingFirmware} in progress...
                  </div>
                </div>
              )}

              {updateInitiatedTime &&
                (updateStatus == "success" || updateStatus === "failed") && (
                  <div>
                    <div style={{ fontSize: "110%" }}>Update History</div>
                    <div
                      style={{
                        color: "#777",
                        fontSize: "91%",
                      }}
                    >
                      {format(new Date(updateInitiatedTime), "MMM d, HH:mm ")} -
                      Initiated{" "}
                      {formatDistanceToNow(new Date(updateInitiatedTime))} ago
                    </div>
                    <div style={{ marginTop: "10px" }}>
                      {secondsSinceInitiated > (30*60) ? ( // older than 30 minutes dont state the success/failure
                      <>
                      Firmware update was initiated on {" "}
                      {format(new Date(updateInitiatedTime), "MMM d, HH:mm ")}{" "}
                      to version {updatePendingFirmware}
                      
                      </>  
                    ) : (
                        <>

                        Firmware update was issued{" "}
                        {updateStatus === "success"
                          ? "successfully"
                          : updateStatus === "failed"
                          ? "unsuccessfully"
                          : ""}{" "}
                        on{" "}
                        {format(new Date(updateInitiatedTime), "MMM d, HH:mm ")}{" "}
                        to version {updatePendingFirmware}
                        </>

                      )}
                    </div>
                  </div>
                )}
            </div>

            }
          </>
        )}
      </div>
    );
  }
}
